import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function DownloadMusic() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/download-music" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="How to download music" />
      <p>
        All your purchased music is at your User Menu - <Link to="/shop/downloads">My Music</Link>
      </p>
      <p>
        You can either download album by album as single zips or track by track.
      </p>
      <ul>
        <li>
          In order to download <strong>the whole release</strong>, please click on the box with the download arrow icon on the right. It
          will be downloaded as a zip archive., which will have to be unzipped after.
        </li>
        <li>
          In order to download <strong>track by track</strong>, please click on the download icon next to the track. The track will be
          downloaded as a single Mp3 file.
        </li>
      </ul>
      <p>
        You can also download on <strong>the page where the release is located</strong>, e.g.
        <Link to="/release/black-nova-limited-edition-169320">Black Nova (limited edition)</Link>{' '}
        There you will see the same icons. Use them in the same way in order to download music.
      </p>
      <p>
        <strong>Bought tracks have no expiration date and can be downloaded whenever and wherever you want.</strong>
      </p>
      <p>
        If you are not sure, whether the track has downloaded, please check the <strong>downloads folder</strong> on your PC.
      </p>
      <p>
        The default download locations are different, depending on the browser and OS. Usually, the download location is
        changeable.
      </p>
      <p>
        Here please find the download location tutorial for the most common browsers.
      </p>
      <h3>Google Chrome</h3>
      <p>
        You can choose a location on your computer where downloads should be saved by default or pick a specific
        destination for each download.
      </p>
      <ol>
        <li>
          On your computer, open Chrome.
        </li>
        <li>
          At the top right, click More More and then <strong>Settings</strong>.
        </li>
        <li>
          At the bottom, click <strong>Advanced</strong>.
        </li>
        <li>
          Under the &quot;Downloads&quot; section, adjust your download settings:
          <ul>
            <li>
              To change the default download location, click <strong>Change</strong> and select where you&apos;d like your files to be
              saved.
            </li>
            <li>
              <strong>
                If you&apos;d rather choose a specific location for each download, check the box next to &quot;Ask where to save
                each file before downloading.&quot;
              </strong>
            </li>
          </ul>
        </li>
      </ol>

      <h3>Default download locations</h3>
      <p>
        If you didn&apos;t change your default download location, then Google Chrome downloads files to the following
        locations:
      </p>
      <ul>
        <li>
          <strong>Windows 10, 8, 7 and Vista</strong>: <code>C:\Users\&lt;username&gt;\Downloads</code>
        </li>
        <li>
          <strong>Mac</strong>: <code>/Users/&lt;username&gt;/Downloads</code>
        </li>
        <li>
          <strong>Linux</strong>: <code>/home/&lt;username&gt;/Downloads</code>
        </li>
      </ul>

      <p>
        <a
          href="https://support.google.com/chrome/answer/95759?hl=en&visit_id=1-636607780352932511-3663970510&rd=1"
          rel="noopener noreferrer"
          target="_blank"
        >
          See more information how to find downloaded files with Google Chrome
        </a>
      </p>

      <h3>Mozilla Firefox</h3>
      <p>
        File downloads are saved in the folder specified in Firefox Options . To change that folder:
      </p>
      <ol>
        <li>Click the menu button Menu and choose Options.</li>
        <li>
          In the General panel, find the <strong>Downloads</strong> section under Files and Applications.
        </li>
        <li>
          Click the Browse button next to the <strong>Save files</strong> to entry.
        </li>
        <li>Choose the downloads folder you wish to use.</li>
      </ol>
      <p>
        <a
          href="http://mzl.la/1xLsqyl"
          rel="noopener noreferrer"
          target="_blank"
        >
          See more information how to find downloaded files with Mozilla Firefox
        </a>
      </p>

      <h3>Safari</h3>
      <p>
        <a
          href="https://support.apple.com/guide/safari/download-items-from-the-web-sfri40598/mac"
          rel="noopener noreferrer"
          target="_blank"
        >
          See more information how to find downloaded files with Safari
        </a>
      </p>

      <h3>Internet Explorer</h3>
      <ol>
        <li>
          Open Internet Explorer, select the <strong>Tools</strong> button, and then select <strong>View downloads</strong>.
        </li>
        <li>
          In the <strong>View Downloads</strong> dialog box, select <strong>Options</strong> in the lower left corner.
        </li>
        <li>
          Choose a different default download location by selecting <strong>Browse</strong>, and then
          select <strong>OK</strong> when you&apos;re done.
        </li>
      </ol>
      <p>
        <a
          href="https://support.microsoft.com/en-us/help/17436/windows-internet-explorer-download-files-from-web"
          rel="noopener noreferrer"
          target="_blank"
        >
          See more information how to find downloaded files with Internet Explorer
        </a>
      </p>
      <HelpContactUs subject={4} />
    </div>
  );
}
